import {Timestamped} from 'common/src/modules/movie/movieRendering';
import getMovieValue from 'common/src/modules/movie/utils/getMovieValue';
import {MoviePath, Value} from 'common/src/modules/movie/moviePrimitives.types';
import getMaskPathValue from 'common/src/modules/movie/utils/getMaskPathValue';

function isKeyframeValue<G>(value: G | Value<number[]>): value is Value<number[]> {
  return value !== null && typeof value === 'object' && ('val' in value || 'k' in value);
}

function applyKeyframe<G>(data: G, time: number): Timestamped<G> {
  if (!data) return data as Timestamped<G>;

  if (isKeyframeValue(data)) {
    if ('c' in data) return getMaskPathValue(data as unknown as MoviePath, time) as Timestamped<G>;

    return getMovieValue(data, time) as Timestamped<G>;
  }

  if (Array.isArray(data)) return data.map((v) => applyKeyframe(v, time)) as Timestamped<G>;
  if (typeof data === 'object')
    return Object.fromEntries(
      Object.entries(data).map(([key, value]) => [key, applyKeyframe(value, time)]),
    ) as Timestamped<G>;

  return data as Timestamped<G>;
}

export default applyKeyframe;
